/**
 * A header lookup box left empty takes its value from the first grid row the lookup fills, e.g. GDN/GP-MR Consignee from
 * the C.N.'s consignee. The clerk can still change it; a box already filled is never overwritten.
 *
 *   <input name="ConsigneeId" data-kit-ac=… data-kit-ac-target="Form.ConsigneeId" data-kit-row-default="consignee,consigneeId" />
 *   (text key, id key in the row lookup's answer; the id goes into the box's data-kit-ac-target)
 */
document.addEventListener("kit:row-filled", (e) => {
  const data = (e as CustomEvent<Record<string, unknown>>).detail;
  const form = (e.target as Element).closest("form");
  form?.querySelectorAll<HTMLInputElement>("input[data-kit-row-default]").forEach((box) => {
    const [textKey = "", idKey = ""] = (box.dataset.kitRowDefault ?? "").split(",");
    const id = form.querySelector<HTMLInputElement>(`input[name='${box.dataset.kitAcTarget}']`);
    if (box.value.trim() || data[textKey] == null || !id || data[idKey] == null) return;
    box.value = String(data[textKey]);
    id.value = String(data[idKey]);
  });
});
